import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import {
  faBars,
  faShoppingCart,
  faUser,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../../context/AuthContext"; // Importăm contextul de autentificare
import { useCart } from "../../context/CartContext";
import { getAuth } from "firebase/auth";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [produseOpen, setProduseOpen] = useState(false);
  const [showProductsList, setShowProductsList] = useState(false);
  const { currentUser } = useContext(AuthContext); // Obținem utilizatorul curent din context
  const navigate = useNavigate();
  const { cart, updateCartCount } = useCart();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleLogout = () => {
    const auth = getAuth();
    auth
      .signOut()
      .then(() => {
        navigate("/login"); // Redirecționează utilizatorul la pagina de login după deconectare
      })
      .catch((error) => {
        console.log("Eroare la deconectare:", error);
      });
  };

  const handleMouseEnter = () => {
    if (window.innerWidth > 1024) {
      setProduseOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 1024) {
      setProduseOpen(false);
    }
  };

  const handleProduseClick = (e) => {
    e.preventDefault();
    if (window.innerWidth <= 1024) {
      setShowProductsList(true);
    } else {
      window.location.href = "/produse";
    }
  };

  const handleBackClick = () => {
    const productList = document.querySelector(".product-list");
    if (productList) {
      productList.classList.add("exit");
      setTimeout(() => {
        setShowProductsList(false);
        productList.classList.remove("exit");
      }, 500);
    }
  };

  const toggleMenuProduse = () => {
    setShowProductsList(false); // Închide lista de produse
    setMenuOpen(false); // Închide meniul principal
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">
          <img src="/logo-inverted.png" alt="Logo" />
        </Link>
      </div>
      <div className="hamburger" onClick={toggleMenu}>
        <FontAwesomeIcon icon={faBars} />
      </div>
      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        {!showProductsList ? (
          <>
            <li>
              <Link to="/" onClick={toggleMenu}>
                Acasă
              </Link>
            </li>
            <li onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
              <Link to="/produse" onClick={handleProduseClick}>
                Produse
              </Link>
              <ul className={`dropdown ${produseOpen ? "open" : ""}`}>
                <li>
                  <Link to="/produse" onClick={toggleMenuProduse}>
                    Toate Produsele
                  </Link>
                </li>
                <li>
                  <Link
                    to="/produse?category=ghiozdane"
                    onClick={toggleMenuProduse}
                  >
                    Ghiozdane
                  </Link>
                </li>
                <li>
                  <Link
                    to="/produse?category=poșete"
                    onClick={toggleMenuProduse}
                  >
                    Poșete
                  </Link>
                </li>
                <li>
                  <Link
                    to="/produse?category=genți Elegante"
                    onClick={toggleMenuProduse}
                  >
                    Genți Elegante
                  </Link>
                </li>
                <li>
                  <Link
                    to="/produse?category=borsete"
                    onClick={toggleMenuProduse}
                  >
                    Borsete
                  </Link>
                </li>
                <li>
                  <Link
                    to="/produse?category=altele"
                    onClick={toggleMenuProduse}
                  >
                    Altele
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/about" onClick={toggleMenu}>
                Despre
              </Link>
            </li>

            {/* Verifică dacă utilizatorul este admin */}
            {currentUser && currentUser.role === "admin" && (
              <li>
                <Link to="/admin" onClick={toggleMenu}>
                  Administrare Produse
                </Link>
              </li>
            )}
            {currentUser && currentUser.role === "admin" && (
              <li>
                <Link to="/orders" onClick={toggleMenu}>
                  Administrare Comenzi
                </Link>
              </li>
            )}
          </>
        ) : (
          <div className="product-list">
            <li className="back-button" onClick={handleBackClick}>
              <span className="arrow-tip">&lt;</span>
              <span className="back-text">ÎNAPOI</span>
            </li>
            <br />
            <li>
              <Link to="/produse" onClick={toggleMenuProduse}>
                Toate Produsele
              </Link>
            </li>
            <br />
            <li>
              <Link
                to="/produse?category=ghiozdane"
                onClick={toggleMenuProduse}
              >
                Ghiozdane
              </Link>
            </li>
            <br />
            <li>
              <Link to="/produse?category=poșete" onClick={toggleMenuProduse}>
                Poșete
              </Link>
            </li>
            <br />
            <li>
              <Link
                to="/produse?category=genți Elegante"
                onClick={toggleMenuProduse}
              >
                Genți Elegante
              </Link>
            </li>
            <br />
            <li>
              <Link to="/produse?category=borsete" onClick={toggleMenuProduse}>
                Borsete
              </Link>
            </li>
            <br />
            <li>
              <Link to="/produse?category=altele" onClick={toggleMenuProduse}>
                Altele
              </Link>
            </li>
          </div>
        )}
      </ul>
      <div className="user-icon">
        <Link to="/cart">
          <div className="cart-icon-wrapper">
            <FontAwesomeIcon icon={faShoppingCart} />
            {cart.length > 0 && (
              <span className="cart-count">{cart.length}</span>
            )}
            {/* Afișează numărul de produse */}
          </div>
        </Link>
        {currentUser ? (
          <FontAwesomeIcon
            icon={faSignOutAlt}
            className="exit-icon"
            onClick={handleLogout}
          />
        ) : (
          <Link to="/login">
            <FontAwesomeIcon icon={faUser} />
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
